import { Text } from '@cleartax/wg-library-typography';
import SanitizedHTML from 'react-sanitized-html';
import {
  TSearchHighlight,
  TSearchItem
} from '../../../../../../../pages/services/[planSeoSlug]/api/types';
import { triggerRedirectionOverLay } from '../../../../../../utils/utils/redirectionOverlay';
import styles from './sanitize.module.css';

export interface IMobileCustomSearchResult {
  searchItem: TSearchItem;
  seachHighlights: TSearchHighlight;
}

export const MobileCustomSearchResult: React.FC<IMobileCustomSearchResult> = ({
  searchItem,
  seachHighlights,
}) => {
  const nameHighlight = seachHighlights.find(
    (highlight) => highlight.field === 'name'
  );

  return (
    <Text
      mergeClasses="override"
      type="a"
      href={`/services/${searchItem.seo_slug}/p`}
      className={`${styles.customMark} cursor-pointer p-4 block w-full font-normal text-brand-1000 sm:text-base`}
      onClick={() => triggerRedirectionOverLay(false)}
    >
      {nameHighlight ? (
        <SanitizedHTML
          className={
            'sm:overflow-ellipsis sm:whitespace-nowrap sm:overflow-hidden sm:max-w-full'
          }
          html={nameHighlight.snippet}
        />
      ) : (
        searchItem.name
      )}
    </Text>
  );
};
